import { __generator, __values } from "tslib";
import { HandleError } from './error-strategies';
export function ObjectPathGet(obj, path) {
    for (var i = 0, l = path.length; i < l; i++) {
        obj = obj[path[i]];
    }
    return obj;
}
export function ObjectPathSet(obj, path, value) {
    var last = path.length - 1;
    for (var i = 0; i < last; i++) {
        obj = obj[path[i]];
    }
    obj[last] = value;
}
function ObjectPathDelete(obj, path) {
    var last = path.length - 1;
    for (var i = 0; i < last; i++) {
        obj = obj[path[i]];
    }
    return delete (obj[last]);
}
export function ObjectPathExists(obj, path) {
    for (var i = 0, l = path.length; i < l; i++) {
        if (path[i] in obj) {
            obj = obj[path[i]];
        }
        else {
            return false;
        }
    }
    return true;
}
export function GetPrototypeChain(target) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(target !== null)) return [3, 2];
                return [4, target];
            case 1:
                _a.sent();
                target = Object.getPrototypeOf(target);
                return [3, 0];
            case 2: return [2];
        }
    });
}
export function GetOwnProperties(target) {
    return Object.getOwnPropertyNames(target)
        .concat(Object.getOwnPropertySymbols(target));
}
export function GetProperties(target) {
    var iterator, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                iterator = GetPrototypeChain(target);
                _a.label = 1;
            case 1:
                if (!!(result = iterator.next()).done) return [3, 3];
                return [5, __values(GetOwnProperties(result.value))];
            case 2:
                _a.sent();
                return [3, 1];
            case 3: return [2];
        }
    });
}
export function HasOwnProperty(target, propertyKey) {
    return Object.prototype.hasOwnProperty.call(target, propertyKey);
}
export function HasProperty(target, propertyKey) {
    return (propertyKey in target);
}
export function GetOwnPropertyDescriptors(target) {
    return Object.entries(Object.getOwnPropertyDescriptors(target))[Symbol.iterator]();
}
export function GetPropertyDescriptors(target) {
    var excludes, properties, iterator, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                excludes = new Set([
                    'constructor',
                    '__proto__',
                    '__defineGetter__',
                    '__defineSetter__',
                    '__lookupGetter__',
                    '__lookupSetter__',
                ]);
                properties = new Set();
                iterator = GetPrototypeChain(target);
                _a.label = 1;
            case 1:
                if (!!(result = iterator.next()).done) return [3, 3];
                return [5, __values(GetOwnProperties(result.value)
                        .filter(function (propertyKey) {
                        if (excludes.has(propertyKey) || properties.has(propertyKey)) {
                            return false;
                        }
                        else {
                            properties.add(propertyKey);
                            return true;
                        }
                    })
                        .map(function (propertyKey) {
                        return [propertyKey, Object.getOwnPropertyDescriptor(result.value, propertyKey)];
                    }))];
            case 2:
                _a.sent();
                return [3, 1];
            case 3: return [2];
        }
    });
}
export function Implements(target, source, level) {
    if (level === void 0) { level = 'exists'; }
    if (target === null) {
        return false;
    }
    else if (source === null) {
        return true;
    }
    else {
        var targetProperties = (level === 'exists')
            ? new Set(GetProperties(target))
            : void 0;
        var iterator = GetProperties(source);
        var result = void 0;
        while (!(result = iterator.next()).done) {
            switch (level) {
                case 'exists':
                    if (!targetProperties.has(result.value)) {
                        return false;
                    }
                    break;
                case 'type':
                    if (typeof target[result.value] !== typeof source[result.value]) {
                        return false;
                    }
                    break;
                case 'strict':
                    if (target[result.value] !== source[result.value]) {
                        return false;
                    }
                    break;
                default:
                    throw new TypeError("Expected 'type' or 'strict' as level");
            }
        }
        return true;
    }
}
export function MustImplement(target, source, level) {
    if (level === void 0) { level = 'exists'; }
    var targetProperties = (level === 'exists')
        ? new Set(GetProperties(target))
        : void 0;
    var iterator = GetProperties(source);
    var result;
    while (!(result = iterator.next()).done) {
        switch (level) {
            case 'exists':
                if (!targetProperties.has(result.value)) {
                    throw new Error("The source property '" + result.value + "' is missing in target");
                }
                break;
            case 'type':
                if (typeof target[result.value] !== typeof source[result.value]) {
                    throw new Error("The source property '" + result.value + "' has a different type in target");
                }
                break;
            case 'strict':
                if (target[result.value] !== source[result.value]) {
                    throw new Error("The source property '" + result.value + "' is not the same as in target");
                }
                break;
            default:
                throw new TypeError("Expected 'type' or 'strict' as level");
        }
    }
}
export function GetPropertyDescriptor(target, propertyKey) {
    var descriptor;
    var iterator = GetPrototypeChain(target);
    var result;
    while (!(result = iterator.next()).done
        && ((descriptor = Object.getOwnPropertyDescriptor(result.value, propertyKey)) === void 0)) { }
    return descriptor;
}
export function CopyOwnDescriptors(source, destination, conflictStrategy) {
    Object.entries(Object.getOwnPropertyDescriptors(source)).forEach(function (_a) {
        var key = _a[0], descriptor = _a[1];
        if (!HasOwnProperty(destination, key) || HandleError(function () { return new Error("Property '" + key + "' already exists"); }, conflictStrategy)) {
            Object.defineProperty(destination, key, descriptor);
        }
    });
    return destination;
}
export function CopyDescriptors(source, destination, conflictStrategy) {
    var iterator = GetPropertyDescriptors(source);
    var result;
    var _loop_1 = function () {
        var _a = result.value, key = _a[0], descriptor = _a[1];
        if (!HasProperty(destination, key) || HandleError(function () { return new Error("Property '" + key + "' already exists"); }, conflictStrategy)) {
            Object.defineProperty(destination, key, descriptor);
        }
    };
    while (!(result = iterator.next()).done) {
        _loop_1();
    }
    return destination;
}
export function SetConstructor(target, _constructor) {
    Object.defineProperty(target, 'constructor', {
        value: _constructor,
        writable: true,
        configurable: true,
        enumerable: false,
    });
    return target;
}
export function SetFunctionName(target, name) {
    Object.defineProperty(target, 'name', Object.assign(Object.getOwnPropertyDescriptor(target, 'name'), { value: name }));
    return target;
}
//# sourceMappingURL=object-helpers.js.map